import Image from "next/image";
import IMAGES from "@/public/assets/img";

const ComparisonOptions = ({ comparisonData }) => {
  return (
    <section  className={`${comparisonData?.bgBanner ? "my-24 sm:my-20" : "mb-sp-100 sm:mb-20" }`}>
      <div className="container xm:px-2 px-3">
        <div
          className={`${
            comparisonData?.bgBanner
              ? "min-h-[400px] sm:min-h-[270px] rounded-xl relative"
              : ""
          }`}
        >
          {/* Background Image */}
          {comparisonData.bgBanner && (
            <Image
              priority
              src={comparisonData.bgBanner}
              width={1100}
              height={500}
              alt="Feature Background"
              className="absolute inset-0 max-w-none w-full h-full"
            />
          )}
         <div className={`${comparisonData?.bgBanner ? "relative z-10 py-20 px-16 sm:px-4" : ""}`}>
            <h2 className="text-center text-xxl font-medium text-baseBlack mb-5">
              {comparisonData.title}
            </h2>

            <div className="flex gap-1 justify-center sm:flex-col">
              <div className="flex flex-col gap-2 min-w-[180px] font-medium mt-5 text-right mr-1 sm:text-left sm:mt-0">
                <p className="font-semibold text-lg">Parameter</p>
                {comparisonData.parameters.map((param, i) => (
                  <p key={i} className="text-base2 text-baseBlack">
                    {param}
                  </p>
                ))}
              </div>

              {comparisonData.options.map((option, idx) => (
                <div
                  key={idx}
                  className={`flex flex-col gap-2 rounded-lg px-2 py-5 min-w-[280px] shadow-md sm:mt-2 ${
                    option.highlight
                      ? "border border-[#9CD6C4] bg-[#F0FFF0]"
                      : "border border-[#FAE0E1] bg-[#FEF4EF]"
                  }`}
                >
                  <p
                    className={`font-semibold text-lg mb-mxp ${
                      option.highlight ? "text-[#059A6D]" : "text-black"
                    }`}
                  >
                    {option.title}
                  </p>

                  {option.values.map((item, i) => (
                    <div key={i} className="flex items-center gap-2">
                      {item.check ? (
                        <Image
                          src={IMAGES.ImportFactoring.yes}
                          width={24}
                          height={20}
                        />
                      ) : (
                        <Image
                          src={IMAGES.ImportFactoring.no}
                          width={24}
                          height={24}
                        />
                      )}
                      <span
                        className={`text-gray-800 font-medium ${
                          option.highlight ? "text-lg" : "text-base2"
                        }`}
                      >
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonOptions;
